module.exports = __webpack_public_path__ + "band_2.eab7c8c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_2.png
// module id = 9m2M
// module chunks = 0